import { useCallback, useEffect, useState } from 'react';

/**
 * 2026-10-29 · **편성표에 광고 시간을 그릴 것인가**(기기 로컬 선호 · `docs/45` §18.7). 회차 사이·중간 광고의 띠, ONAIR CSPM 브레이크, 라이브
 * 이벤트 앞뒤 광고 — 편성표의 광고 표시 전부를 함께 켜고 끈다. **기본은 켬이다.**
 *
 * `ads-enabled.ts` 의 모양 그대로다(키 상수 + try/catch 읽기·쓰기 + 같은 문서 `CustomEvent` + 다른 탭 `storage` + 훅). **표시만 바꾼다** —
 * 상자의 자리·폭은 광고를 품은 벽시계 그대로이고, 광고가 나가는지는 `bloom.adsEnabled` 의 일이다(둘을 섞지 않는다).
 */
const STORAGE_KEY = 'bloom.epgShowAds';

const CHANGE_EVENT = 'bloom:epg-show-ads';

export function epgAdsVisible(): boolean {
  try {
    // **`'false'` 만 끈 것이다.** 값이 없거나 이상하면 켬이다.
    return localStorage.getItem(STORAGE_KEY) !== 'false';
  } catch {
    return true;
  }
}

export function setEpgAdsVisible(next: boolean): void {
  try {
    localStorage.setItem(STORAGE_KEY, next ? 'true' : 'false');
  } catch {
    // 저장하지 못해도 이 탭에서는 아래 이벤트로 바뀐다. 새로고침하면 켬으로 돌아간다.
  }
  window.dispatchEvent(new CustomEvent(CHANGE_EVENT));
}

export function useEpgAdsVisible(): [boolean, (next: boolean) => void] {
  const [visible, setVisible] = useState(epgAdsVisible);

  useEffect(() => {
    const sync = () => {
      setVisible(epgAdsVisible());
    };
    window.addEventListener(CHANGE_EVENT, sync);
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener(CHANGE_EVENT, sync);
      window.removeEventListener('storage', sync);
    };
  }, []);

  const set = useCallback((next: boolean) => {
    setEpgAdsVisible(next);
    setVisible(next);
  }, []);

  return [visible, set];
}
